/**
 * Today: the first screen after sign-in. Staff get the clock card. Directors
 * also get the shortcuts to what needs them. Classrooms and attendance land
 * here when they are built.
 */

import { Link, Navigate } from "react-router-dom";
import { useMe } from "../auth/MeProvider";
import { Card, Notice, PageHeader } from "../components/ui";
import { ClockCard, useClockStatus } from "./TimeClock";

function greeting(timezone: string) {
  const hour = Number(new Intl.DateTimeFormat("en-US", { timeZone: timezone, hour: "numeric", hourCycle: "h23" }).format(new Date()));
  return hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
}

function StaffClock() {
  const { data, error, reload } = useClockStatus();
  if (error) return <Notice>{error}</Notice>;
  return data ? <ClockCard status={data} onChange={reload} /> : null;
}

export function Home() {
  const { me, isDirector } = useMe();

  // An operator with no school goes straight to the operations board.
  if (!me.org) return <Navigate to="/ops" replace />;

  const firstName = me.user.fullName?.split(" ")[0];

  return (
    <div>
      <PageHeader
        title={`${greeting(me.org.timezone)}${firstName ? `, ${firstName}` : ""}`}
        detail={`${me.org.name}, signed in as ${me.role?.label ?? "member"}.`}
      />
      <div className="space-y-6">
        {me.role?.isStaff ? <StaffClock /> : null}

        {isDirector ? (
          <div className="grid gap-4 sm:grid-cols-2">
            <Link to="/time/review" className="block">
              <Card className="h-full transition-colors hover:border-leaf-200">
                <h2 className="font-semibold">Time review</h2>
                <p className="mt-1 text-sm text-stone-600">Approve this week's hours and export them for payroll.</p>
              </Card>
            </Link>
            <Link to="/settings/support-access" className="block">
              <Card className="h-full transition-colors hover:border-leaf-200">
                <h2 className="font-semibold">Support access</h2>
                <p className="mt-1 text-sm text-stone-600">Let Cubby support see your school while they help you.</p>
              </Card>
            </Link>
          </div>
        ) : null}

        <Card>
          <h2 className="font-semibold">Something not working, or missing?</h2>
          <p className="mt-1 text-sm text-stone-600">
            Cubby is being built with your school. Tell us what gets in your way.{" "}
            <Link to="/help" className="font-medium text-leaf-700 hover:text-leaf-800">
              Send feedback
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
